"use strict";

var BufferScramble = {

    computeMap: function (buffer_length, chunk_size, seed) {
        var MAX_INT32 = 2147483647;
        var MINSTD = 16807;

        function nextInteger() {
            seed *= MINSTD;
            seed %= MAX_INT32;
            return seed;
        }

        var last_chunk_size = buffer_length % chunk_size;
        var nb_chunks = Math.floor(buffer_length / chunk_size);
        if (last_chunk_size) {
            nb_chunks++;
        }

        var map = [];
        var offset = 0;

        for (var i = 0; i < nb_chunks; i++) {

            map.push({
                origin: i,
                offset: offset,
                size: chunk_size,
                order: nextInteger()
            });

            offset += chunk_size;
        };

        // on corrige la taille du dernier élément si différent de 0
        if (last_chunk_size && map.length) {
            map[map.length - 1].size = last_chunk_size;
        }

        map = map.sort(function (a, b) {
            return a.order - b.order;
        });

        return map;
    },

    scrambleNode: function (buf_src, chunk_size, seed) {
        // TODO : voir pour ne pas recalculer à chaque la map à chaque fois
        var map = this.computeMap(buf_src.byteLength, chunk_size, seed);

        var buf_dest = new Buffer(buf_src.byteLength);
        
        var offset = 0, i, chunk;
        for (i=0;i<map.length;i++) {
            chunk = map[i];
                    buf_dest.set(buf_src.slice(chunk.offset, chunk.offset + chunk.size), offset);
            offset += chunk.size;
        }

        /*for (var i = 0; i < view_dest.length; i++) {
            view_dest[i] = view_dest[i] ^ 0x1;
        }*/

        return buf_dest;
    },

    unscramble: function (buf_src, chunk_size, seed) {
        // TODO : voir pour ne pas recalculer à chaque la map à chaque fois
        var map = this.computeMap(buf_src.byteLength, chunk_size, seed);

        var buf_dest = new ArrayBuffer(buf_src.byteLength);
        var view_dest = new Uint8Array(buf_dest);
        var view_src = new Uint8Array(buf_src);

        var offset = 0, i, chunk;
        for (i=0;i<map.length;i++) {
            chunk = map[i];
            view_dest.set(view_src.slice(offset, offset + chunk.size), chunk.offset);
            offset += chunk.size;
        }

        /*for (var i = 0; i < view_dest.length; i++) {
            view_dest[i] = view_dest[i] ^ 0x1;
        }*/

        return view_dest;
    }
};

module.exports = BufferScramble;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@immanens-com/pv5js/reader/lib/buffer-scramble.js
// module id = 52
// module chunks = 0